// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Zambia from '../_raw/flag/icon_flag_zambia.png';

export default () => <img src={Zambia} alt="Zambia" />;
